import type { EuthanasiaFeePayload } from '../interfaces';
import { API } from '@Providers';

export default async function (payload: EuthanasiaFeePayload) {
  const endpoint = '/api/shelter/animal/update-cart-animal-euthanasia-fee';

  return API({ endpoint, method: 'put', payload });
}
